import { render, staticRenderFns } from "./ConcreteFormulaList.vue?vue&type=template&id=50dd5f16&scoped=true"
import script from "./ConcreteFormulaList.vue?vue&type=script&lang=js"
export * from "./ConcreteFormulaList.vue?vue&type=script&lang=js"
import style0 from "./ConcreteFormulaList.vue?vue&type=style&index=0&id=50dd5f16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dd5f16",
  null
  
)

export default component.exports